<template>
  <!-- 마크다운 텍스트 블록 — useAssistant.renderMarkdown(이스케이프 후 변환)으로 XSS 안전 -->
  <div class="ab-text" v-html="html"></div>
</template>

<script>
import { renderMarkdown } from '@/composables/useAssistant'

/**
 * @component TextBlock
 * @description data.markdown 을 안전 HTML로 렌더하는 텍스트 블록.
 */
export default {
  name: 'TextBlock',
  props: {
    data: { type: Object, default: () => ({}) }
  },
  computed: {
    html() {
      return renderMarkdown(this.data && this.data.markdown ? this.data.markdown : '')
    }
  }
}
</script>

<style scoped>
.ab-text { white-space: normal; font-size: 14px; line-height: 1.5; }
.ab-text :deep(:first-child) { margin-top: 0; }
.ab-text :deep(:last-child) { margin-bottom: 0; }
.ab-text :deep(h1), .ab-text :deep(h2), .ab-text :deep(h3) { margin: 8px 0 4px; font-weight: 700; line-height: 1.3; }
.ab-text :deep(h1) { font-size: 16px; }
.ab-text :deep(h2) { font-size: 15px; }
.ab-text :deep(h3) { font-size: 14px; }
.ab-text :deep(p) { margin: 4px 0; }
.ab-text :deep(ul), .ab-text :deep(ol) { margin: 4px 0; padding-left: 20px; }
.ab-text :deep(code) {
  background: var(--color-gray-100, #eef0f3);
  border-radius: 4px;
  padding: 1px 4px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 12.5px;
}
.ab-text :deep(table) { display: block; width: 100%; overflow-x: auto; border-collapse: collapse; margin: 6px 0; font-size: 12.5px; }
.ab-text :deep(th), .ab-text :deep(td) { border: 1px solid var(--color-gray-200, #e0e0e0); padding: 4px 8px; text-align: left; white-space: nowrap; }
.ab-text :deep(th) { background: var(--color-primary-100, #C5D1E3); font-weight: 600; }
</style>
